import { render, staticRenderFns } from "./areas-contrato.vue?vue&type=template&id=0cee3ddc&scoped=true"
import script from "./areas-contrato.vue?vue&type=script&lang=js"
export * from "./areas-contrato.vue?vue&type=script&lang=js"
import style0 from "./areas-contrato.vue?vue&type=style&index=0&id=0cee3ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee3ddc",
  null
  
)

export default component.exports